import styled from 'styled-components';

// Main filters container
export const FiltersContainer = styled.div`
	display: flex;
	flex-direction: row;
	justify-content: space-between;
	gap: 8px;
	margin-top: 30px;
	margin-bottom: 30px;

	@media (max-width: 768px) {
		margin-top: 20px;
		margin-bottom: 20px;
	}
`;

// Category chips section
export const ChipsSection = styled.div`
	display: flex;
	gap: 12px;
	align-items: center;
	font-size: 16px;
`;

export const ChipsContainer = styled.div`
	display: flex;
	gap: 12px;
	flex-wrap: wrap;
	align-items: center;
`;

export const DesktopChipsContainer = styled.div`
	display: flex;
	gap: 12px;
	flex-wrap: wrap;
	align-items: center;

	@media (max-width: 768px) {
		display: none;
	}
`;

export const MobileChipsContainer = styled.div`
	display: none;
	gap: 12px;
	flex-wrap: wrap;
	align-items: center;

	@media (max-width: 768px) {
		display: flex;
	}
`;

export const Divider = styled.div`
	width: 1px;
	height: 24px;
	background-color: ${({ theme }) => theme.colors.transparent.light15};
	align-self: center;
`;

export const ResetFilterContainer = styled.div`
	display: flex;
	align-items: center;
	gap: 4px;
	white-space: nowrap;
`;

export const ChipsDivider = styled.div`
	color: ${({ theme }) => theme.colors.text.alwaysWhite};
	margin: 0 4px;
`;

export const ResetButton = styled.div<{ $disabled?: boolean }>`
	cursor: ${props => (props.$disabled ? 'not-allowed' : 'pointer')};
	white-space: nowrap;
	font-size: 14px;
	color: ${({ theme }) => theme.colors.text.subtitle};
	display: flex;
	gap: 4px;
	align-items: center;
	opacity: ${props => (props.$disabled ? 0.6 : 1)};

	svg {
		fill: ${({ theme }) => theme.colors.text.alwaysWhite};
	}

	&:hover {
		color: ${props => (props.$disabled ? props.theme.colors.text.subtitle : props.theme.colors.text.alwaysWhite)};
	}
`;

// Right actions container (sort button + mobile icon)
export const RightActionsContainer = styled.div`
	display: flex;
	flex-shrink: 0;
`;

// Sort dropdown
export const SortDropdown = styled.div<{ $disabled?: boolean; $round?: boolean }>`
	font-size: 16px;
	align-items: center;
	background-color: ${({ theme }) => theme.colors.control.dark};
	border-radius: ${props => (props.$round ? '12px' : '4px')};
	color: ${({ theme }) => theme.colors.text.alwaysWhite};
	cursor: ${props => (props.$disabled ? 'not-allowed' : 'pointer')};
	display: flex;
	justify-content: center;
	gap: 4px;
	width: 138px;
	height: 42px;
	position: relative;
	transition: all 0.2s linear;
	opacity: ${props => (props.$disabled ? 0.6 : 1)};

	svg {
		fill: ${({ theme }) => theme.colors.text.alwaysWhite};
	}

	&:hover {
		background-color: ${props =>
			props.$disabled ? props.theme.colors.control.dark : props.theme.colors.control.darkHover};
	}

	@media (max-width: 768px) {
		display: none;
	}
`;

export const DropdownContent = styled.div<{ $isOpen?: boolean }>`
	background-color: ${({ theme }) => theme.colors.background.main};
	border-radius: 8px;
	color: ${({ theme }) => theme.colors.text.body};
	left: 0;
	padding: 8px 0;
	position: absolute;
	top: 120%;
	width: 170px;
	z-index: 1;
	display: ${props => (props.$isOpen ? 'block' : 'none')};
`;

export const DropdownItem = styled.div<{ $selected?: boolean }>`
	cursor: pointer;
	margin-bottom: 3px;
	padding: 6px 16px;
	transition: all 0.2s linear;
	background-color: ${props => (props.$selected ? props.theme.colors.transparent.light10 : 'transparent')};

	&:hover {
		background-color: ${({ theme }) => theme.colors.transparent.light10};
	}
`;

// Mobile filter modal
export const FilterModal = styled.div<{ $isOpen?: boolean }>`
	background-color: ${({ theme }) => theme.colors.background.modalView};
	position: fixed;
	top: 0;
	bottom: 0;
	left: 0;
	right: 0;
	z-index: 999;
	display: ${props => (props.$isOpen ? 'block' : 'none')};
`;

export const ModalContainer = styled.div`
	position: fixed;
	bottom: 0;
	left: 0;
	right: 0;
	background-color: ${({ theme }) => theme.colors.background.secondary};
	border-radius: 16px 16px 0 0;
	padding: 24px 16px 4px 16px;
`;

export const ModalTitle = styled.div`
	color: ${({ theme }) => theme.colors.text.alwaysWhite};
	margin-bottom: 24px;
	text-align: center;
	font-weight: 500;
	font-size: 18px;
`;

export const ModalSection = styled.div`
	color: ${({ theme }) => theme.colors.text.subtitle};
	margin-bottom: 16px;
	font-weight: 500;
	font-size: 16px;
`;

export const ModalSortOptions = styled.div`
	display: flex;
	gap: 12px;
	margin-top: 12px;
`;

export const ModalSortItem = styled.div<{ $selected?: boolean; $disabled?: boolean; $round?: boolean }>`
	background-color: ${props =>
		props.$selected ? props.theme.colors.transparent.light30 : props.theme.colors.transparent.light10};
	color: ${({ theme }) => theme.colors.text.alwaysWhite};
	border-radius: ${props => (props.$round ? '100px' : '4px')};
	padding: 11px 14px;
	cursor: ${props => (props.$disabled ? 'not-allowed' : 'pointer')};
	font-size: 14px;
	opacity: ${props => (props.$disabled ? 0.6 : 1)};
`;

export const ModalCategoryChips = styled.div`
	display: flex;
	gap: 12px;
	flex-wrap: wrap;
	margin-top: 12px;
`;

export const ModalButtons = styled.div`
	display: flex;
	flex-direction: column;
	gap: 12px;
	margin-top: 24px;
	margin-bottom: 16px;
`;

export const CloseButton = styled.div`
	position: absolute;
	top: 16px;
	right: 16px;
	cursor: pointer;
	width: 24px;
	height: 24px;
	display: flex;
	align-items: center;
	justify-content: center;

	svg {
		fill: ${({ theme }) => theme.colors.text.alwaysWhite};
	}
`;

export const MobileFilterIcon = styled.div`
	cursor: pointer;
	display: none;
	align-items: center;
	justify-content: center;
	flex-shrink: 0;
	width: 24px;
	height: 24px;

	svg {
		fill: ${({ theme }) => theme.colors.text.alwaysWhite};
	}

	@media (max-width: 768px) {
		display: flex;
	}
`;
